module.exports = __webpack_public_path__ + "img/industrias_de_nutraceuticos-logo.d253592b.svg";